<template>
  <div class="planningSeries-container">
    <div class="header" style="margin-bottom:10px">
      <el-steps :active="currentWorkshopIndex" simple align-center>
        <el-step
          v-for="(step, idx) in workshopsInPlanning"
          :key="idx"
          :title="step.workshopName"
          :status="getStepStatus(idx)"
        ></el-step>
      </el-steps>
    </div>
    <div v-loading="pageLoading" class="planningSeries-main-container">
      <el-table
        ref="planningSelectionList"
        :data="items"
        border
        fit
        highlight-current-row
        style="width: 100%;"
        height="600"
        @row-dblclick="rowDblClick"
      >
        <el-table-column :label="$t('planning.seriesNumber')" property="yarnDescription">
          <template slot-scope="scope">
            <span>{{ scope.row['seriesNumber'] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('planning.series')" property="series">
          <template slot-scope="scope">
            <span>{{ scope.row['seriesDescription'] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('planning.tickets')" property="amountOfTickets">
          <template slot-scope="scope">
            <span>{{ scope.row['amountOfTickets'] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="amountString" property="amountOfCapacity">
          <template slot-scope="scope">
            <span>{{ scope.row['amountOfCapacity'] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('planning.orders')" property="amountOfOrders">
          <template slot-scope="scope">
            <span>{{ scope.row['amountOfOrders'] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('planning.storeAttribute')" property="storeAttributeDescription">
          <template slot-scope="scope">
            <span>{{ scope.row['storeAttributeName'] || 'n.v.t.' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding-top:10px;text-align:right;clear:both;">
        <editor-button
          :icon-only="false"
          :disabled="pageLoading"
          button-translation="planning.makeSeries"
          action="primary"
          style="float:right;"
          @click="makeSeries()"
        />
      </div>
    </div>
    <el-dialog
      :title="selectedSeries.seriesNumber + ' ' + selectedSeries.seriesDescription"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :width="'1500px'"
    >
      <dialog-order-list
        :series-i-d="selectedSeries.productionPlanningSeriesID"
        :planning-option="selectedSeries.planningOption"
        :in-planning="true"
      >
      </dialog-order-list>
      &nbsp;
    </el-dialog>
  </div>
</template>

<script>
import EditorButton from '@/components/crud/EditorButton';
import { closeCurrentTag } from '@/utils/tags';
import DialogOrderList from './DialogOrderList';
import { PlanningOption } from '@/utils/constants';

export default {
  name: 'PlanningSeriesList',
  components: {
    EditorButton,
    DialogOrderList
  },
  props: {
    entity: {
      default: '',
      type: String
    },
    permissionCode: String,
    domainID: Number,
    selectedPlanningOption: Number
  },
  data() {
    return {
      pageLoading: false,
      dialogVisible: false,
      // planning
      amountString: '',
      workshopsInPlanning: [],
      selectedSeries: {},
      useFiliationType: false,

      currentDomain: '',
      currentWorkshop: '',
      currentWorkshopID: 0,
      currentWorkshopIndex: 0,
      items: []
    };
  },
  watch: {
    selectedPlanningOption() {
      this.oneTimeSetup();
    }
  },
  created() {},
  methods: {
    rowDblClick(row) {
      this.dialogVisible = true;
      this.selectedSeries = row;
    },
    async oneTimeSetup() {
      this.pageLoading = true;
      this.getRequiredAmountTranslation();
      await this.$store
        .dispatch('productionPlanningSelection/getWorkshopsInPlanning', {
          domainID: this.domainID,
          planningOption: this.selectedPlanningOption
        })
        .then(data => {
          const currentWorkshop = data.find(w => !w.seriesFinalYN);
          if (currentWorkshop) {
            this.currentWorkshopID = currentWorkshop.workshopID;
            this.currenWorkshopName = currentWorkshop.workshopName;
            this.workshopsInPlanning = data;
            this.currentWorkshopIndex = this.workshopsInPlanning.findIndex(
              w => w.workshopID === this.currentWorkshopID
            );
            this.getSeriesForWorkshop(this.currentWorkshopID);
          } else {
            this.$store
              .dispatch('productionPlanning/finishPlanningOption', {
                domainID: this.domainID,
                planningOption: this.selectedPlanningOption
              })
              .finally(() => {
                this.pageLoading = false;
                this.$emit('action', 'finishSelectionStep');
              });
          }
        });
    },
    getSeriesForWorkshop(workshopID) {
      this.pageLoading = true;
      this.$store
        .dispatch('productionPlanningSeries/getSeriesForWorkshop', {
          domainID: this.domainID,
          workshopID: workshopID,
          planningOption: this.selectedPlanningOption
        })
        .then(data => {
          this.items = data;
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    async makeSeries() {
      this.pageLoading = true;
      let finish = false;
      try {
        await this.$store.dispatch('productionPlanningSeries/finishSeriesForWorkshop', {
          domainID: this.domainID,
          workshopID: this.currentWorkshopID,
          planningOption: this.selectedPlanningOption
        });
        const currentWorkshopIndex = this.workshopsInPlanning.findIndex(w => w.workshopID === this.currentWorkshopID);
        this.workshopsInPlanning[currentWorkshopIndex].seriesFinalYN = true;
        const nextWorkshopIndex = currentWorkshopIndex + 1;
        if (nextWorkshopIndex < this.workshopsInPlanning.length) {
          const nextWorkshop = this.workshopsInPlanning[nextWorkshopIndex];
          this.currentWorkshopIndex = nextWorkshopIndex;
          this.currentWorkshopID = nextWorkshop.workshopID;
          this.currenWorkshopName = nextWorkshop.workshopName;
          const data = await this.$store.dispatch('productionPlanningSeries/getSeriesForWorkshop', {
            domainID: this.domainID,
            workshopID: nextWorkshop.workshopID,
            planningOption: this.selectedPlanningOption
          });
          this.items = data;
        } else {
          finish = true;
          await this.$store.dispatch('productionPlanning/finishPlanningOption', {
            domainID: this.domainID,
            planningOption: this.selectedPlanningOption
          });
        }
      } finally {
        this.pageLoading = false;
      }
      if (finish) {
        this.$emit('action', 'finishSelectionStep');
      }
    },
    close() {
      closeCurrentTag(this);
    },
    getStepStatus(idx) {
      const workshop = this.workshopsInPlanning[idx];
      if (workshop.seriesFinalYN) {
        return 'success';
      } else if (idx === this.currentWorkshopIndex) {
        return 'finish';
      } else {
        return 'wait';
      }
    },
    getRequiredAmountTranslation() {
      switch (this.selectedPlanningOption) {
        case PlanningOption.Panel:
          this.amountString = this.$i18n.t('planning.amount') + ' ' + this.$i18n.t('planning.panels');
          break;
        case PlanningOption.NetCurtainRoomHigh:
          this.amountString = this.$i18n.t('planning.amount') + ' ' + this.$i18n.t('planning.netCurtainsMeters');
          break;
        case PlanningOption.CurtainRoomHigh:
          this.amountString = this.$i18n.t('planning.amount') + ' ' + this.$i18n.t('planning.curtainsMeters');
          break;
        case PlanningOption.RomanBlind:
          this.amountString = this.$i18n.t('planning.amount') + ' ' + this.$i18n.t('planning.romanBlinds');
          break;
        case PlanningOption.Cutting:
          this.amountString = this.$i18n.t('planning.amount') + ' ' + this.$i18n.t('planning.cuttings');
          break;
      }
    }
  }
};
</script>
<style lang="scss">
.clear-input-button {
  float: right;
  background-color: #ff8c8c;
  color: white;

  &:hover {
    background-color: #ffb3b3;
    color: white;
  }
}

.planningSeries-container {
  background-color: white;

  .capacity-footers {
    color: #606266;
    display: block;
    margin-top: 10px;
    font-size: 1.6em;
  }
}
</style>
